import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import Link from "../../utils/Link";
import Button from "../Button";

// import data from "./data"

const QuickFAQ = ({ data }) => {
  const { userLanguage } = useContext(LanguageContext);
  const { t } = useTranslation();

  return (
    <div className="wrapper">
      <div className="site-block__title site-block__title--center">
        <div className="site-block__title-left">
          <font>
            <font>{t("quickFAQ.title")}</font>
          </font>
        </div>
      </div>
      <div className="wrapper wrapper--1000">
        <div className="faq-list">
          {data.questions
            .filter(({ help_item }) => help_item && help_item.title)
            .map(({ id, help_item }) => (
              <div key={id} className="faq-list__item">
                <div className="faq-list__item-inner">
                  <div className="faq-list__title">
                    <font>
                      <font>{text(help_item.title, userLanguage)}</font>
                    </font>
                  </div>
                  {help_item.content.map((c) => (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: text(c, userLanguage),
                      }}
                    />
                  ))}
                </div>
              </div>
            ))}
        </div>
        <div className="text-center">
          <Link to="/help">
            <Button mt>
              {t("quickFAQ.seeAll")}
              <i class="i-arrow-circle-right" style={{ marginLeft: "5px" }}></i>
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default QuickFAQ;
